import axios from "axios";
import { JohokuBranchMstModel } from "models";
import { IAPIResult } from "models/interfaces";

export async function entryList(token: string) {
  // await Utils.sleep(300);

  const response = await axios.get<IAPIResult<JohokuBranchMstModel[]>>(
    "/api.d/v1/entry/johoku-branch-mst/list",
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
}

export async function list() {
  // await Utils.sleep(300);

  const response = await axios.get<IAPIResult<JohokuBranchMstModel[]>>(
    "/api.d/v1/ec/johoku-branch-mst/list"
  );
  return response.data;
}
